import React from 'react'

const projectData = [
	{
		title: 'Just Press Record',
		description: 'A film editing company who produce and edit films for their customers. I was taksed to design and develop an ecommerce website that allowed customers to make bookings to hire camera equipment to improve the companies administrative process.',
		role: 'Design, Development',
		link: 'http://justpressrecord.co.uk',
		alink: 'just-press-record',		
		image: './assets/images/projects/justpressrecord.png',
		backgroundPosition: 'top left'
	},
	{
		title: 'Organiser',
		description: 'Started as a side project in response to my need for a simple calendar with a to do list, I created this application using plain Javascript. Still currently under construction but will be released for public use very soon!',
		role: 'Design, Development',
		link: '',
		alink: 'organiser',
		image: './assets/images/projects/organiser.png',
		backgroundPosition: 'center center'
	},
	{
		title: 'Click Engine',
		description: 'Created for a digital studio, I developed the site based on the designs provided. The creative nature of the design made for an interesting build but resulted in a modern and captivating end result.',
		role: 'Development',
		link: 'http://theclickengine.com',
		alink: 'click-engine',		
		image: './assets/images/projects/clickengine.png',
		backgroundPosition: 'center center'
	},	
	{
		title: 'The UXER',
		description: 'Developed for a local User Experience specialist to display his work. The sites unique layout required careful planning beforehand to ensure a smooth build.',
		role: 'Development',
		link: 'http://theuxer.co.uk',
		alink: 'the-uxer',		
		image: './assets/images/projects/theuxer.png',
		backgroundPosition: 'top left'
	},
	{
		title: 'Personal Portfolio',
		description: 'Built using React, my aim for this site was for it to look great on all screen sizes, and to ensure that all animations ran smoothly. No link provided for obvious reasons!',
		role: 'Design, Development',
		link: '',
		alink: 'this-site',		
		image: './assets/images/projects/personalportfolio.png',
		backgroundPosition: 'top left'
	}		
]

export default projectData;


/** WEBPACK FOOTER **
 ** ./js/project-data.js
 **/